import { getOrThrow } from 'quartz/globalState/api';
import { HISTORY_INSTANCE, HISTORY_BASE_PATH } from './globalState';

/**
 * Returns the current history instance for the app. This should only be used in exceptional cases where the history
 * instance is not available through React context with `useHistory` or `withRouter`.
 *
 * @example
 * ```ts
 * import { getHistory } from 'quartz/framework/routing/service';
 *
 * const href = getHistory().createHref({ pathname: '/some/path' });
 * ```
 */
export const getHistory = () => getOrThrow(HISTORY_INSTANCE);

/**
 * Returns the history base path extracted from the URL during history initialization.
 * This should only be used outside React components where `useHistoryBasePath` is not available.
 *
 * @example
 * ```ts
 * import { getHistoryBasePath } from 'quartz-core/framework/history';
 *
 * const { basePathname, params } = getHistoryBasePath();
 * ```
 */
export const getHistoryBasePath = () => getOrThrow(HISTORY_BASE_PATH);